import React, { Component } from "react"
import styled, { injectGlobal, keyframes } from "styled-components"
import Flexbox from "flexbox-react"
import logo from "./lattjo.png"
import gambina from "./gambina.png"
import jallu from "./jallu.png"
import gofore from "./gofore.svg"
import cage from "./cage.png"

const fontFamily = "font-family: 'Neucha', cursive;"

injectGlobal`
  body {
    background-color: #343f68;
    color: #fff;
  }
`

const rotate360 = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const AppContainer = styled.div`
  text-align: center;
  height: 100%;
`

const Header = styled.div`
  background-color: #ff8551;
  background-image: url(${jallu}), url(${gambina});
  background-position: 10% top, 90% top;
  background-repeat: no-repeat;
  background-size: contain;
  height: 150px;
  padding: 20px;
  color: white;
`

const Title = styled.h2`
  ${fontFamily}
  font-weight: 400;
  text-transform: uppercase;
  font-size: 44px;
  margin: 0.5em 0;
  color: #343f68;
  text-shadow: 0 0 10px #fff;
`

const Intro = styled.div`
  font-size: large;
`

const Logo = styled.img`
  animation: ${rotate360} infinite 10s linear;
  height: 90px;
`

const CheckpointContainer = styled(Flexbox)`
  height: 60px;
`

const CheckpointName = styled(Flexbox)`
  ${fontFamily}
  font-weight: 400;
  font-size: 20px;
`

const Input = styled.input`
  border: 0;
  margin: 10px;
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
  flex: 1;
`

const Footer = styled.div`
  background-image: url(${gofore});
  background-repeat: no-repeat;
  background-position: center;
  height: 40px;
  margin: 40px 0;
`

const Cage = styled.img`
  width: 40px;
  height: 40px;
`

class Checkpoint extends Component {
  render() {
    const { checkpoint, changeResult, index, highlight } = this.props
    let { name, score } = checkpoint

    if (name === "Cage") {
      name = <Cage src={cage} alt="Cage" />
    }

    return (
      <CheckpointContainer flexDirection="row">
        <CheckpointName
          flex="1"
          justifyContent="center"
          alignItems="center"
          style={{ color: highlight ? "#ff8551" : "#fff" }}
        >
          {name}
        </CheckpointName>
        <Flexbox flex="1" justifyContent="flex-start" alignItems="center">
          <Input
            value={score}
            onChange={event => changeResult(index, event.currentTarget.value)}
          />
        </Flexbox>
      </CheckpointContainer>
    )
  }
}

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      team: {
        name: "JOUKKUE",
        score: ""
      },
      results: [
        {
          name: "Nurkka",
          score: ""
        },
        {
          name: "Puzzle",
          score: ""
        },
        {
          name: "Kikkeri",
          score: ""
        },
        {
          name: "Jousting",
          score: ""
        },
        {
          name: "Cage",
          score: ""
        }
      ]
    }
  }

  componentDidMount() {
    const state = JSON.parse(window.localStorage.getItem("results"))
    if (state) {
      this.setState({
        ...state
      })
    }
  }

  save() {
    window.localStorage.setItem("results", JSON.stringify(this.state))
  }

  setResults = (index, value) => {
    const results = [...this.state.results]
    results[index] = { ...results[index], score: value }
    this.setState({ results: results }, () => {
      this.save()
    })
  }

  setName = (index, name) => {
    this.setState({ team: { ...this.state.team, score: name } }, () => {
      this.save()
    })
  }

  render() {
    return (
      <AppContainer>
        <Header>
          <Logo src={logo} alt="logo" />
          <Title>Tuparit</Title>
        </Header>
        <Intro>
          <Checkpoint
            checkpoint={this.state.team}
            index={0}
            changeResult={this.setName}
            highlight={true}
          />
          <Flexbox flex="1" flexDirection="column">
            {this.state.results.map((result, index) => {
              return (
                <Checkpoint
                  key={result.name}
                  checkpoint={result}
                  index={index}
                  changeResult={this.setResults}
                />
              )
            })}
          </Flexbox>
        </Intro>
        <Footer />
      </AppContainer>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js